/**
 * Development-only logging helpers.
 * Keeps production runtime free of non-essential console noise.
 */

const IS_DEV = (() => {
  try {
    return Boolean(import.meta.env?.DEV);
  } catch {
    return false;
  }
})();

type LogArgs = unknown[];

export function devLog(...args: LogArgs): void {
  if (!IS_DEV) return;
  console.log(...args);
}

export function devWarn(...args: LogArgs): void {
  if (!IS_DEV) return;
  console.warn(...args);
}
